import {styled} from '@mui/material/styles';
import Button from '@mui/material/Button';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import InputLabel from "@mui/material/InputLabel";
import {FlexRowWrapper} from "../Row";
import React, {useState} from "react";
import CloseIcon from "@mui/icons-material/Close";
import {IconButton} from "@mui/material";

const VisuallyHiddenInput = styled('input')({
    clip: 'rect(0 0 0 0)',
    clipPath: 'inset(50%)',
    height: 1,
    overflow: 'hidden',
    position: 'absolute',
    bottom: 0,
    left: 0,
    whiteSpace: 'nowrap',
    width: 1,
});

const InputLabelContainer = styled(InputLabel)`
  margin-bottom: 0.5rem;
`;

const UploadButton = ({title, onChange, value, accept}) => {
    const [file, setFile] = useState(value);

    const handleChangeFile = (event) => {
        const {target: {files}} = event
        setFile(files[0])
        if (onChange) {
            onChange(files[0])
        }
    }

    const removeFiles = () => {
        setFile("")
        if (onChange) {
            onChange("")
        }
    }

    return (
        <div>
            <InputLabelContainer>
                {title ? title : "File"}
            </InputLabelContainer>
            <FlexRowWrapper style={{flexWrap: "nowrap"}}>
                <div style={{minWidth: "130px"}}>
                    <Button component="label" style={{color: "#283665", borderColor: "#283665"}} variant="outlined"
                            startIcon={<CloudUploadIcon style={{color: "#283665"}}/>}>
                        Upload file
                        <VisuallyHiddenInput 
                            type="file" 
                            accept={accept}
                            onChange={handleChangeFile}
                        />
                    </Button>
                </div>
                <div style={{width: "auto", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis"}}>
                    {file?.name || file?.split("/").pop()}
                </div>
                {(file?.name || file?.split("/").pop()) ?
                    <IconButton
                        color="primary" size="small"
                        onClick={() => removeFiles()}>
                        <CloseIcon style={{color: "red"}}/>
                    </IconButton> : null
                }
            </FlexRowWrapper>
        </div>
    )
}

export default UploadButton;
